import { render, staticRenderFns } from "./ClassificationDegreeUpdate.vue?vue&type=template&id=1f41ed7d&"
import script from "./ClassificationDegreeUpdate.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports